import constants from '@/Constants';
import { PdfDashboardSesrjReport } from '@/modules/pdf/pdf_dashboard_sesrj';
import { EventReportTableData } from '@/modules/pdf/pdf_dashboard_sesrj/types';
import axios from 'axios';
import React, { useEffect, useState } from 'react';

export const ReportSESRJDashboard: React.FC<{
  reportId: string;
  workspaceSlug: string;
}> = ({ reportId, workspaceSlug }) => {
  const [report, setReport] = useState<EventReportTableData | null>(null);

  useEffect(() => {
    const fetchReport = async () => {
      try {
        const url = constants.REPORTS_API_URL || '';

        const parsedUrl = url.toLowerCase().replace('{{workspace}}', 'sesrj');

        const { data, status } = await axios.get<EventReportTableData>(
          `${parsedUrl}pdf_json_by_export_id?export_id=${reportId}`,
          {
            headers: {
              Authorization: constants.REPORTS_API_AUTHORIZATION_TOKEN,
            },
          },
        );

        if (status === 200) {
          setReport(data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchReport();
  }, [reportId, workspaceSlug]);

  return (
    <div style={{ height: '100%', width: '100%' }}>
      {report && <PdfDashboardSesrjReport report={report} />}
    </div>
  );
};
